import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import QAmountField from 'components/QAmountField';
import InvestmentTransactionBaseForm from './InvestmentTransactionBaseForm';
import { makeNumericKeyDownHandler, sanitizeNumericValue } from './numericInputHelpers';
import type { InvestmentTransactionFormikProps } from './types';

const handleNumericKeyDown = makeNumericKeyDownHandler();

const InvestmentTransactionAddSharesForm = (props: InvestmentTransactionFormikProps) => {
  const { formik } = props;

  const [pricePerUnit, setPricePerUnit] = useState<number>();

  useEffect(() => {
    formik.registerField('costBasis', {
      validate: (value: number | null | undefined) => (value ? undefined : 'please enter valid amount'),
    });
    formik.registerField('units', {
      validate: (value: number | null | undefined) =>
        typeof value === 'number' && value ? undefined : 'field is required',
    });
    return () => {
      formik.unregisterField('costBasis');
      formik.unregisterField('units');
    };
  }, [formik]);

  useEffect(() => {
    const costBasis = typeof formik.values.costBasis === 'number' ? formik.values.costBasis : 0;
    const units = typeof formik.values.units === 'number' ? formik.values.units : 0;
    if (costBasis !== 0 && units) {
      const newPricePerUnit = Math.abs(costBasis / units);
      if (newPricePerUnit !== pricePerUnit) {
        setPricePerUnit(newPricePerUnit);
      }
    }
  }, [formik, formik.values.costBasis, formik.values.units, pricePerUnit]);

  return (
    <>
      <InvestmentTransactionBaseForm formik={formik} />

      <Box display='flex' alignItems='center' gap={1}>
        <QAmountField
          id='total-amount'
          editable
          label='Total Amount'
          sx={{ minWidth: 110 }}
          noNegatives
          value={Math.abs(formik.values.costBasis ?? 0)}
          variant='filled'
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            formik.setFieldValue('costBasis', Math.abs(Number(event.target.value)))
          }
          error={Boolean(formik.submitCount > 0 && formik.errors.costBasis)}
          helperText={(formik.submitCount > 0 && formik.errors.costBasis) || ''}
        />
        =
        <TextField
          id='units'
          label='Shares quantity'
          type='number'
          inputProps={{ min: 1, inputMode: 'decimal' }}
          sx={{ minWidth: 110 }}
          variant='filled'
          value={formik.values.units != null ? Math.abs(formik.values.units) : ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const sanitized = sanitizeNumericValue(event.target.value);
            formik.setFieldValue('units', sanitized ? Number(sanitized) : null);
          }}
          error={Boolean(formik.submitCount > 0 && formik.errors.units)}
          helperText={(formik.submitCount > 0 && formik.errors.units) || ''}
        />
        x
        <QAmountField
          id='price-per-share'
          editable
          disabled
          // textFieldVariant="standard"
          InputProps={{
            readOnly: true,
            // disableUnderline: true,
          }}
          sx={{ minWidth: 110 }}
          expectedSign='positive'
          value={pricePerUnit}
          variant='filled'
          label='Price per share'
        />
      </Box>
    </>
  );
};

export default InvestmentTransactionAddSharesForm;
